import { useState } from "react";
import AdminActions from "../components/AdminActions";

interface AdminDashboardProps {
  adminId: string;
  userName: string;
  onLogout: () => void;
}

export default function AdminDashboard({ adminId, userName, onLogout }: AdminDashboardProps) {
  const [, setActiveGameId] = useState<string | null>(null);

  return (
    <div style={{ padding: "2rem" }}>
      <AdminActions adminId={adminId} onActiveGameChange={setActiveGameId} onLogout={onLogout} />
    </div>
  );
}
